import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
} from '@angular/core';

@Component({
  selector: 'ss-www-carousel-controls',
  imports: [CommonModule],
  templateUrl: './carousel-controls.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselControlsComponent {
  @Input({ required: true }) currentIndex!: number;
  @Input({ required: true }) items!: any[];
  @Input() theme: string = 'dark';
  @Output() nextIndex = new EventEmitter<number>();

  nextHovered = signal<boolean>(false);
  previousHovered = signal<boolean>(false);

  checkScreenWidth(): number {
    return window.innerWidth;
  }

  onClickAtIndex(index: number) {
    this.emitNextIndex(index);
  }

  onPreviousIndex() {
    let nextIndex = this.currentIndex - 1;
    if (nextIndex < 0) {
      nextIndex = this.items.length - 1;
    }
    this.emitNextIndex(nextIndex);
  }

  onNextIndex() {
    let nextIndex = this.currentIndex + 1;
    if (nextIndex >= this.items.length) {
      nextIndex = 0;
    }
    this.emitNextIndex(nextIndex);
  }

  private emitNextIndex(index: number) {
    this.nextIndex.emit(index);
  }
}
